export enum UiRoutes {
  LOGIN = '/login',
  HEADINGS = '/headings',
  EMPLOYEES = '/employees',
  DRAFTS = '/drafts',
  HISTORIES = '/histories',
  LIQUIDATIONS = '/liquidations',
  NOT_ALLOWED = '/not-allowed',
  ADMIN_AD = '/admin-ad',
  ADMIN_AL = '/admin-al',
}
